import alert from "./alerts.json";

const RestrictionConfig = {
    alert,
};

export default RestrictionConfig;